// src/components/OutboundLink.js

import React from 'react';
import { trackOutboundLink } from '../utils/analytics';

const OutboundLink = ({ href, children, className, label }) => {
  const handleClick = () => {
    trackOutboundLink(label || href);
  };

  return (
    <a
      href={href}
      className={className}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

export default OutboundLink;